import React, { useState } from 'react';
import { Dropdown } from './Dropdown';
import { PAIRS, AVAILABLE_PAIRS } from 'data/analysisDisplay';

interface PairSelectProps {
  open: boolean;
  anchor: HTMLElement | null;
  selected: string;
  onSelect: (pair: string) => void;
  onClose: () => void;
}

export function PairSelect({ open, anchor, selected, onSelect, onClose }: PairSelectProps) {
  const [search, setSearch] = useState('');
  const filtered = PAIRS.filter((p) => p.toLowerCase().includes(search.toLowerCase()));

  return (
    <Dropdown open={open} anchor={anchor} onClose={onClose} width={200}>
      <div className="pair-search-wrap">
        <input
          className="pair-search"
          placeholder="Search pair..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus
        />
      </div>
      <div className="pair-list">
        {filtered.map((item) => {
          const isAvailable = AVAILABLE_PAIRS.has(item);
          const isActive = item === selected;
          return (
            <button
              key={item}
              type="button"
              className={`pair-item${isActive ? ' active' : ''}${isAvailable ? '' : ' disabled'}`}
              onClick={() => {
                if (!isAvailable) return;
                onSelect(item);
                onClose();
              }}
            >
              <span className="pair-item-text">{item}</span>
              {!isAvailable && <span className="pair-item-soon">Coming soon</span>}
            </button>
          );
        })}
        {filtered.length === 0 && <div className="dropdown-empty">No matches</div>}
      </div>
    </Dropdown>
  );
}
